// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './errorBoundary';
import { isBackendOutageError, isServerErrorRoute } from './utils/serverHealth';
import { captureClientError } from './utils/errorReporting';

const userRole = localStorage.getItem('userRole');
const IsDev = userRole === 'DEV';

//Global catch - prevent infinite redirect loops
const MAX_REDIRECTS = 1;

const getRedirectAttempts = () => {
  try {
    return parseInt(sessionStorage.getItem('globalRedirectAttempts') || '0', 10);
  } catch {
    return 0;
  }
};

const incrementRedirectAttempts = () => {
  try {
    const current = getRedirectAttempts();
    sessionStorage.setItem('globalRedirectAttempts', (current + 1).toString());
  } catch { }
};

window.onerror = function (message, source, lineno, colno, error) {
  console.error("Global error caught:", message, error);
  if (isServerErrorRoute()) return;
  captureClientError(error || message, {
    component: 'window.onerror',
    source,
    line: lineno,
    column: colno,
    page: window.location.pathname
  });

  const attempts = getRedirectAttempts();
  // Only redirect once to prevent infinite loops
  if (!IsDev && attempts < MAX_REDIRECTS && !window.location.href.includes('/it-error')) {
    incrementRedirectAttempts();
    window.location.replace("/it-error?error=true");
  }
};

window.onunhandledrejection = function (event) {
  console.error("Unhandled promise rejection:", event.reason);
  if (isServerErrorRoute() || isBackendOutageError(event.reason)) return;
  captureClientError(event.reason, {
    component: 'window.onunhandledrejection',
    page: window.location.pathname
  });

  const attempts = getRedirectAttempts();
  if (!IsDev && attempts < MAX_REDIRECTS && !window.location.href.includes('/it-error')) {
    incrementRedirectAttempts();
    window.location.replace("/it-error?error=true");
  }
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
  // </React.StrictMode>
);
